/* eslint-disable angular/factory-name */
angular.
module("digiexam.services").
factory("examStatus", function examStatus() {
	"use strict";
	return {
		NOT_SELECTED: -1, // LTI specific status where the exam has not been selected for an LTI course.
		NOT_STARTED: 0,
		PLANNED: 1,
		ACTIVE: 2,
		NOT_GRADED: 3,
		GRADED: 4,
		PUBLISHED: 5,
	};
});
